import React from 'react';

const Page403 = () => {
    return (
        <div className='container'>
            <div className='row justify-content-center'>
                <div className='col-md-6'>
                    <div className='card card-body mt-5'>
                        <h1>Page 403 | Forbidden</h1>
                        <p>Access Denied! As you are not an admin</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Page403;